import { defineMessages } from 'react-intl';

export default defineMessages({
  yes: { id: 'global_trovitAds_yes', defaultMessage: 'Yes' },
  no: { id: 'global_trovitAds_no', defaultMessage: 'No' },
  areaMetric: { id: 'global_floor_area_metric_short', defaultMessage: 'ft²', description: 'homes' },
  mileage: { id: 'global_mileage', defaultMessage: 'Miles', description: 'cars' },
  // eslint-disable-next-line no-template-curly-in-string
  currencyPrint: { id: 'global_currency_print', defaultMessage: '${%s}' },
  dateRecent: { id: 'mobile_wm_date_recent', defaultMessage: 'Date (most recent first)' },
  dateOldest: { id: 'mobile_wm_date_oldest', defaultMessage: 'Date (oldest first)' },
  priceHighFirst: { id: 'mobile_wm_price_high_first', defaultMessage: 'Price (highest first)' },
  priceLowFirst: { id: 'mobile_wm_price_low_first', defaultMessage: 'Price (lowest first)' },
  priceAreaHighFirst: {
    id: 'mobile_wm_price_area_high_first',
    defaultMessage: '£ / sq. ft (highest first)',
    description: 'homes',
  },
  priceAreaLowFirst: {
    id: 'mobile_wm_price_area_low_first',
    defaultMessage: '£ / sqm (lowest first)',
    description: 'homes',
  },
  relevance: { id: 'mobile_wm_relevancia', defaultMessage: 'Relevance' },
  timeSinceMoreMonth: {
    id: 'global_time_since_more_month',
    defaultMessage: '30+ days',
  },
  timeSinceSince: {
    id: 'global_time_since_since',
    defaultMessage: '{%s} ago',
  },
  timeHourOne: {
    id: 'mobile_wm_time_hour_one',
    defaultMessage: '{%d} hour ago',
  },
  timeHourOther: {
    id: 'mobile_wm_time_hour_other',
    defaultMessage: '{%d} hours ago',
  },
  timeMinuteOne: {
    id: 'mobile_wm_time_minute_one',
    defaultMessage: '{%d} minute ago',
  },
  timeMinuteOther: {
    id: 'mobile_wm_time_minute_other',
    defaultMessage: '{%d} minutes ago',
  },
  timeDayOne: {
    id: 'mobile_wm_time_day_one',
    defaultMessage: '{%d} day ago',
  },
  timeDayOther: {
    id: 'mobile_wm_time_day_other',
    defaultMessage: '{%d} days ago',
  },
});



// WEBPACK FOOTER //
// ./app/utils/messages.js